import {Delta, Layout, Text, usePageContext} from '~/components'
import {calculateDeltaPercentage} from '@eitje/web_components/src/components/graph/helpers'
import {Colors} from '@eitje/assets'

const {mediumGreen, mediumRed} = Colors

export const DeltaPopoutContent = ({seriesPointIndex, apexObject}) => {
	const {selectedSeriesPointIndex} = usePageContext()
	const {data: seriesPoints = []} = apexObject.config.series[0]
	const activeSeriesPointIndex = seriesPointIndex ?? selectedSeriesPointIndex

	return (
		<Layout direction="vertical" gap={0}>
			<DeltaRow t="graphs.delta.last_month" seriesPoints={seriesPoints} seriesPointIndex={activeSeriesPointIndex} periodsBack={1} />
			<DeltaRow t="graphs.delta.last_year" seriesPoints={seriesPoints} seriesPointIndex={activeSeriesPointIndex} periodsBack={12} />
		</Layout>
	)
}

const DeltaRow = ({t, seriesPoints, seriesPointIndex, periodsBack}) => {
	const actual = seriesPoints[seriesPointIndex]?.y
	const comparison = seriesPoints[seriesPointIndex - periodsBack]?.y
	const delta = calculateDeltaPercentage({actual, comparison})

	return (
		<Layout width="full" padding="0 0 0 12" gap={0}>
			<Layout width="full" height={32} padding="9 12 9 16" vertical="center">
				<Text t={t} />
				<Delta value={delta} positive={mediumGreen} negative={mediumRed} bold />
			</Layout>
		</Layout>
	)
}
